import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import { matchPath, withRouter } from 'react-router-dom';
import { getThemeSettingsVariables, isEmptyVariable } from '../../common/Global/commonFunctions';
import { TopTabsLayout } from '../../common/Global/globalStyles.style';

let isDraft = '';
let isTasks = '';
let isObservations = '';
let themeColor = ``;
let themeSettings = getThemeSettingsVariables();
class MasterTopMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAlertDialog:false,
            alertDialogMessage:"",
            screenName:""
        }
        themeSettings = getThemeSettingsVariables();
        isDraft = this.checkActivePath(["/auditeedraftassignmentreport"]);
        isTasks = this.checkActivePath(["/auditeeemployeedrafttasks"]);
        isObservations = this.checkActivePath(["/auditeeemployeedraftobservations"]);
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
           
        }
    }

    checkActivePath = (path) =>{
        themeSettings = getThemeSettingsVariables();
        themeColor = `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`;
       return matchPath(this.props.history.location.pathname, { path });

    }

    handleOnClick = (pathname) => {
        const {unitListId, executionTemplateId} = this.props;
        this.props.history.push({
            pathname,
            state: {
                unitListId,
                executionTemplateId
            }
        })
        window.location.reload();
    }

    render() {
        let width = 12.5;
        if (!isEmptyVariable(this.props.masterMenus)) {
            width = 12.5 * Object.keys(this.props.masterMenus).length
        }
        return (
            <TopTabsLayout themeSettings={this.props.themeSettings}>
                <div className="question-tabs" style={{ marginRight: 0,display:'flex' }}>
                    {this.props.showMainMenu &&
                        <ul 
                        style={{ width: width + "%" }}
                        >
                            <li className={isDraft? "questiontab-active" : "" ? "questiontab-active" : ""}>
                                <a href={Constants.URL_AUDITEE_DRAFT_ASSIGNMENT_REPORT}
                                    style={{color: !isDraft ? themeColor : '', fontWeight: !isDraft ? "bold" : "100px"}}>Draft</a>
                            </li>
                        </ul>
                    }
                    {!isEmptyVariable(this.props.showTaskObservationTab) &&
                        <ul style={{ width: width + "%" }}>
                            <li className={isTasks? "questiontab-active" : "" ? "questiontab-active" : ""}
                            onClick={()=>this.handleOnClick(Constants.URL_AUDITEE_EMPLOYEE_DRAFT_TASKS+"/"+this.props.assignmentId)}>
                                <a href="javascript:void(0);"
                                    style={{color: !isTasks ? themeColor : '', fontWeight: !isTasks ? "bold" : "100px"}}>Tasks</a>
                            </li>
                            <li className={isObservations? "questiontab-active" : "" ? "questiontab-active" : ""}
                            onClick={()=>this.handleOnClick(Constants.URL_AUDITEE_EMPLOYEE_DRAFT_OBSERVATIONS+"/"+this.props.assignmentId)}>
                                <a href="javascript:void(0);"
                                    style={{color: !isObservations ? themeColor : '', fontWeight: !isObservations ? "bold" : "100px"}}>Observations</a>
                            </li>
                        </ul>
                    }
                </div>
            </TopTabsLayout>
        )
    }
}

export default withRouter(MasterTopMenu);